import { render } from "./RankingUser.vue?vue&type=template&id=41aa6ae4&ts=true&lang=pug"
import script from "./RankingUser.vue?vue&type=script&lang=ts"
export * from "./RankingUser.vue?vue&type=script&lang=ts"

import "./RankingUser.vue?vue&type=style&index=0&id=41aa6ae4&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__